<template>
  <div
    :class="[show ? '' : 'hidden']"
    style="background-color: rgba(0,0,0,0.5)"
    class="fixed top-0 left-0 w-full h-full flex items-center shadow-lg overflow-y-auto z-30"
    @click.self="close"
  >
    <div
      class="w-full xs:w-11/12 sm:container mx-auto lg:px-32 rounded-lg overflow-y-auto"
    >
      <div class="bg-gray-900 rounded">
        <div class="flex justify-end pr-4 pt-2">
          <button-icon
            :color="'text-white'"
            :style="'bg-gray-700'"
            @click="close"
          >
            <i class="far fa-times-circle fa-2x"></i
          ></button-icon>
        </div>
        <div class="modal-body py-3 xs:p-2 sm:px-8 sm:py-8">
          <div
            class="responsive-container overflow-hidden relative"
            style="padding-top: 50%"
          >
            <iframe
              width="100%"
              height="100%"
              :src="`https://www.youtube.com/embed/${video}`"
              frameborder="0"
              class="responsive-iframe absolute top-0 left-0 w-full h-full"
              allow="autoplay;encrypted-media"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "movie-modal",
  props: {
    show: Boolean,
    video: String
  },
  methods: {
    close() {
      this.$emit("closeModal");

      this.stopVideos();
    },
    stopVideos() {
      let videos = document.querySelectorAll("iframe, video");
      Array.prototype.forEach.call(videos, function(video) {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          let src = video.src;
          video.src = src;
        }
      });
    }
  },
  unmounted() {
    this.stopVideos();
  }
};
</script>
